<script setup>
import { defineProps, defineEmits, watchEffect, ref, computed } from "vue";
import { fetchWithHeaders } from "@/utils";
import { toDate, toDjangoDate, toTime } from "@/filters";
import dayjs from "dayjs";

const props = defineProps({
    session: {
        type: Object,
        required: true,
    },
    selectedSlot: {
        type: Object,
        default: null,
    },
});
const emit = defineEmits(["slot"]);

const slots = ref([]);
const selectedDate = ref(null);
const selectedSlot = ref(null);
function selectSlot(slot) {
    selectedSlot.value = slot;
    emit("slot", slot);
}

const slotsGroupedByDate = computed(() => {
    return slots.value.reduce((groups, slot) => {
        const date = slot.start.split("T")[0];
        if (!groups[date]) {
            groups[date] = [];
        }
        groups[date].push(slot);
        return groups;
    }, {});
});

function isDateAvailable(date) {
    return Object.prototype.hasOwnProperty.call(slotsGroupedByDate.value, date.replace(/\//g, "-"));
}

function isActive(slot) {
    return slot.pk === selectedSlot.value?.pk;
}

watchEffect(async () => {
    if (props.session) {
        // get list of free slots for session
        const date = toDjangoDate(dayjs().add(new Date().getHours() > window._env_.CANCEL_TIME_DAY_BEFORE_HOUR ? 2 : 1, "day"));
        const url = `${window._env_.API_ENDPOINT}/slots/?session=${props.session.code}&seats_free__gt=0&start__gt=${date}`;
        slots.value = await fetchWithHeaders(url);
        if (!selectedDate.value && slots.value?.length > 0) {
            selectedDate.value = toDjangoDate(slots.value[0].start);
        }
    }
    if (props.selectedSlot) {
        selectedSlot.value = props.selectedSlot;
        selectedDate.value = toDjangoDate(props.selectedSlot.start);
    }
});
</script>
<template>
    <div>
        <div class="row">
            <div class="col-sm-5 q-mb-lg">
                <div class="text-h5 q-my-md">Choix de la date</div>
                <div class="row">
                    <q-date
                        v-model="selectedDate"
                        mask="YYYY-MM-DD"
                        event-color="primary"
                        :options="isDateAvailable"
                        class="q-mx-auto"
                        @update:model-value="selectSlot(null)"
                    />
                </div>
            </div>
            <div class="offset-sm-1 col-sm-6">
                <div class="text-h5 q-my-md">Choix de l'heure</div>
                <q-list v-if="selectedDate" bordered separator>
                    <q-item-label header>Horaires disponibles pour le {{ toDate(selectedDate) }}</q-item-label>

                    <q-item
                        v-for="slot in slotsGroupedByDate[selectedDate]"
                        :key="slot.pk"
                        v-ripple
                        :active="isActive(slot)"
                        active-class="bg-primary text-white"
                        clickable
                        @click="selectSlot(slot)"
                    >
                        <q-item-section avatar>
                            <q-icon name="fa-regular fa-clock" :color="isActive(slot) ? 'white' : 'primary'" />
                        </q-item-section>
                        <q-item-section class="text-bold">{{ toTime(slot.start) }}</q-item-section>
                    </q-item>
                </q-list>
                <p class="text-caption q-mt-md">* Durée réelle dépend du nombre d'examens à consulter.</p>
            </div>
        </div>
    </div>
</template>
